import * as React from 'react';
import { Downloader } from '../../downloader/Downloader';
import {
    ItemDownloadAction as BaseItemDownloadAction,
    DownloadAction as BaseDownloadAction,
    IItemDownloadActionProps as IBaseItemDownloadActionProps,
    IDownloadActionProps as IBaseDownloadActionProps
} from '../../base/actions/download/DownloadAction';
import { IDecoratedProps } from '../../../utilities/components/Decorators';
import { connectToItemCache } from '../../decorators/connectToItemCache';

export type IItemDownloadActionProps = IDecoratedProps<IBaseItemDownloadActionProps, Pick<IBaseItemDownloadActionProps, 'downloader'>, {}>;

export const ItemDownloadAction: React.ComponentType<IItemDownloadActionProps> =
    connectToItemCache((): Pick<IBaseItemDownloadActionProps, 'downloader'> => {
        return {
            downloader: Downloader
        };
    })(BaseItemDownloadAction);

export type IDownloadActionProps = IDecoratedProps<IBaseDownloadActionProps, Pick<IBaseDownloadActionProps, 'downloader'>, {}>;

export const DownloadAction: React.ComponentType<IDownloadActionProps> =
    connectToItemCache((): Pick<IBaseDownloadActionProps, 'downloader'> => {
        return {
            downloader: Downloader
        };
    })(BaseDownloadAction);
